/*
 * @Author: yeertesi
 * @Date: 2023-11-09 18:47:49
 * @LastEditTime: 2023-12-11 16:54:14
 * @LastEditors: yeertesi
 * @Description: 图片链接
 * @FilePath: /nami-activity/client/constants/common-url.ts
 */


// 导航栏用到的 ICON
export enum NAVIGATION_BAR {
  // 返回按钮
  BACK_ICON = '//p0.meituan.net/summary/back-icon.png',
  // 音乐 在播放按钮
  MUSIC_PLAY_ICON = '//p0.meituan.net/summary/music-icon.png',
  // 音乐 在暂停按钮
  MUSIC_PAUSE_ICON = '//p0.meituan.net/summary/pause-icon.png',
  // 分享按钮
  SHARE_ICON = '//p0.meituan.net/summary/shear-icon.png',
  // 场景1
  HEADER_ICON1 = '//p0.meituan.net/summary/header-icon-scenes1.png',
  // 场景2
  HEADER_ICON2 = '//p0.meituan.net/summary/header-icon-scenes2.png',
  // 场景3
  HEADER_ICON3 = '//p0.meituan.net/summary/header-icon-scenes3.png',
  // 场景4
  HEADER_ICON4 = '//p0.meituan.net/summary/header-icon-scenes4.png',
  // 场景5
  HEADER_ICON5 = '//p0.meituan.net/summary/header-icon-scenes5.png',
  // 场景6
  HEADER_ICON6 = '//p0.meituan.net/summary/header-icon-scenes6.png',
  // 场景7
  HEADER_ICON7 = '//p0.meituan.net/summary/header-icon-scenes7.png',
  // 场景8
  HEADER_ICON8 = '//p0.meituan.net/summary/header-icon-scenes8.png',
  // 场景9
  HEADER_ICON9 = '//p0.meituan.net/summary/header-icon-scenes9.png',
  // 场景10
  HEADER_ICON10 = '//p0.meituan.net/summary/header-icon-scenes10.png',
  // 场景11-1
  GENERAL = '//p0.meituan.net/summary/header-icon-scenes11-1.png',
  // 场景11-2
  SILVER = '//p0.meituan.net/summary/header-icon-scenes11-2.png',
  // 场景11-3
  GOLD = '//p0.meituan.net/summary/header-icon-scenes11-3.png',
  // 场景11-4
  BLACK_GOLD = '//p0.meituan.net/summary/header-icon-scenes11-4.png',
  // 场景11-5
  BLACK_GOLD_PLUS = '//p0.meituan.net/summary/header-icon-scenes11-5.png',
  // 场景13
  HEADER_ICON13 = '//p0.meituan.net/summary/header-icon-scenes13.png',

}

export const navigationBars = {
  GENERAL: NAVIGATION_BAR.GENERAL,
  SILVER: NAVIGATION_BAR.SILVER,
  GOLD: NAVIGATION_BAR.GOLD,
  BLACK_GOLD: NAVIGATION_BAR.BLACK_GOLD,
  BLACK_GOLD_PLUS: NAVIGATION_BAR.BLACK_GOLD_PLUS,
};

// 所有场景通用的图片
export enum COMMON_IMG {
  // 纸感背景1
  PAPER_BACKGROUND = `//p0.meituan.net/summary/paper-background`,
  // 下一页图标-黑色
  NEXT_PAGE_IMG_BLACK = `//p0.meituan.net/summary/swipe-next-black.png`,
  // 下一页图标-白色
  NEXT_PAGE_IMG_WHITE = `//p0.meituan.net/summary/swipe-next-white.png`,
  // 页头图标
  HEADER_IMG = '//p0.meituan.net/summary/common-navigation-bar.png',
  // 画圈文字中的画圈装饰
  FONT_CIRCLE = '//p0.meituan.net/summary/font-circle.png',
  // 红心
  HONG_XIN_IMG = '//p0.meituan.net/summary/红心.png',
  // 通用海报
  COMMON_POSTER = '//p0.meituan.net/xuyuan/poster-default.png',
  // 页头icon - 汉堡
  HEAD_ICON_EATING = '//p0.meituan.net/summary/eating-icon.png',
  // 页头icon - 娱乐
  HEAD_ICON_ENTERTAINMENT = '//p0.meituan.net/summary/entertainment-icon.png',
  // 页头icon - 金币
  HEAD_ICON_COIN = '//p0.meituan.net/summary/coin-icon.png',
  // 页头icon - 红心
  HEAD_ICON_HEART = '//p0.meituan.net/summary/heart-icon.png',
  // 异常兜底icon
  ERROR_ICON = '//p0.meituan.net/summary/wuwangicon.png',
  // 太火爆了
  HUO_BAO_ICON = '//p0.meituan.net/summary/wuxiaoxiicn.png',
  // 勾选协议
  CHECKED = '//p0.meituan.net/summary/checked.png',
  // 未勾选协议
  NOT_CHECKED = '//p0.meituan.net/summary/not-checked.png'
}

// 所有音频资源
export enum AUDIO_SOURCE {
  // 背景音乐
  BACKGROUND_MUSIC = `//s3plus.meituan.net/mtouch/project2023/audio/background-audio4.mp3`,
  // 测试占位音效
  TEST_AUDIO = '//s3plus.meituan.net/mtouch/project2023/audio/test0.mp3',
  // 场景音效1(封面)
  SCENES_1 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/1scenes1.mp3',
  // 场景二音效2-1(历史)
  SCENES_2_1 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/1scenes2-1.mp3',
  // 场景二音效2-2(历史)
  SCENES_2_2 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/1scenes2-2.mp3',
  // 场景音效3(外卖)
  SCENES_3 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/4scenes3.mp3',
  // 场景音效4(神券)
  SCENES_4 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/3scense4.mp3',
  // 场景音效5(备注)
  SCENES_5 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/1scense5.mp3',
  // 场景音效6(奶茶)
  SCENES_6 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/1scenes6.mp3',
  // 场景音效7(咖啡)
  SCENES_7 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/2scenes7.mp3',
  // 场景音效8(到家)
  SCENES_8 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/2scenes8.mp3',
  // 场景音效9(记录)
  SCENES_9 = '//s3plus.meituan.net/mtouch/project2023/audio/scenes/scense9.WAV',
  // 场景音效10(拼单)
  SCENES_10 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/4scense10.mp3',
  // 场景音效11(娱乐)
  SCENES_11 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/1scenes11.wav',
  // 场景音效12(许愿)
  SCENES_12_1 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/1scenes12-1.mp3',
  // 场景音效12(许愿)
  SCENES_12_2 = '//s3plus.meituan.net/mtouch/project2023/audio/scenes/scense12.WAV',
  // 场景音效13(备注场景)
  SCENES_13 = '//s3plus.meituan.net/mtouch/project2023/audio/finalscenes/2scense13.mp3'
}

// 音效list
export const AUDIO_EFFECT_LIST = [
  AUDIO_SOURCE.SCENES_1,
  AUDIO_SOURCE.SCENES_2_1,
  AUDIO_SOURCE.SCENES_2_2,
  AUDIO_SOURCE.SCENES_3,
  AUDIO_SOURCE.SCENES_4,
  AUDIO_SOURCE.SCENES_5,
  AUDIO_SOURCE.SCENES_6,
  AUDIO_SOURCE.SCENES_7,
  AUDIO_SOURCE.SCENES_8,
  AUDIO_SOURCE.SCENES_9,
  AUDIO_SOURCE.SCENES_10,
  AUDIO_SOURCE.SCENES_11,
  AUDIO_SOURCE.SCENES_12_1,
  AUDIO_SOURCE.SCENES_12_2,
  AUDIO_SOURCE.SCENES_13
]

// loading页面用到的素材
export enum LOADING_IMG {
  // loading头部图片
  HEAD_IMG = "//p0.meituan.net/summary/loading-head.png",
  // loading bar
  HEAD_BAR = "//p0.meituan.net/summary/loading-bar.png",
  // 完成的部分
  HEAD_FINISH = "//p0.meituan.net/summary/loading-finish.png",
  // 未完成的部分
  HEAD_UNFINISH = "//p0.meituan.net/summary/loading-unfinished.png",
}

// loading页面用到的素材
export enum LOADING {
  // 美团LOGO
  MT_LOGO = '//p0.meituan.net/summary/meituan-logo.png'
}

// 页面链接
export enum PAGE_URL {
  // 授权协议魔方页面链接
  LICENSE_URL = 'https://cube.meituan.com/cube/block/1b5bf76e36bb/267549/index.html',
  // TODO 恢复
  MEITUAN_MINI_URL = 'mt/pages/annual-summary-2023/home',
  // MEITUAN_MINI_URL = 'index/pages/mt/mt',
  WAIMAI_MINI_URL = 'outer_packages/mactivitydyna/pages/annual-summary-2023/home',
  // WAIMAI_MINI_URL = 'index/pages/mt/mt',
}

// 授权弹窗的美团logo
export const MEITUAN_LOGO = '//p0.meituan.net/summary/meituan-logo.png'
